import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { settingsManagementService } from "../services/settings.service";
import {
	CreateSettingPayload,
	UpdateSettingPayload,
} from "../domain/settings.interface";

export const useGetSettings = (selectedAccountId?: string) => {
	return useQuery({
		queryKey: ["settings-management", selectedAccountId],
		queryFn: () => settingsManagementService.findAll(selectedAccountId),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

export const useCreateSetting = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CreateSettingPayload) =>
			settingsManagementService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["settings-management"],
			});
		},
	});
};

export const useUpdateSetting = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			settingId,
			data,
		}: {
			settingId: string;
			data: UpdateSettingPayload;
		}) => settingsManagementService.update(settingId, data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["settings-management"],
			});
		},
	});
};

export const useDeleteSetting = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (settingId: string) =>
			settingsManagementService.remove(settingId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["settings-management"],
			});
		},
	});
};
